angular.module('dnecom')
    .filter('globalTimerToDate', function() {

        return function(timer) {

            if (timer.timer_type != "global") {
                return '';
            }

            return  moment(
                timer.timer_date + ' ' + timer.timer_time + ' ' + timer.timer_suffix,
                'MM/DD/YYYY hh:mm a'
            ).format('YYYY-MM-DD HH:mm:ss');
        };
    });
